export const createModuleAction: <M, A>(moduleName: M, action: A) => string = (moduleName, action) => {
  return `${moduleName}/${action}`;
};
